import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DialogComponent } from '../../../../../@core/components/ui/dialog/dialog.component';
import { IconFieldModule } from 'primeng/iconfield';
import { SelectModule } from 'primeng/select';
import { ButtonComponent } from '../../../../../@core/components/ui/button/button.component';
import { SelectComponent, SelectConfig, SelectOption } from '../../../../../@core/components/ui/select';
import { IContract } from '../../../../models/contract-management.model';
import { ContractService } from '../../../../services/contracts.service';
import { AssetUrlPipe } from '../../../../../@shared/pipes/asset-url.pipe';

@Component({
  selector: 'app-download-doc',
  standalone: true,
  imports: [DialogComponent, IconFieldModule, AutoCompleteModule, ButtonComponent, FormsModule, SelectModule, SelectComponent, AssetUrlPipe],
  templateUrl: './download-doc.component.html',
  styleUrl: './download-doc.component.scss'
})
export class DownloadDocComponent {
  @Input() visibility: boolean = false;
  @Input() contract!: IContract;
  @Output() visibilityChange = new EventEmitter<boolean>();

  downloadOptions: SelectOption[] = [
    { label: 'Pdf Document (.pdf)', value: 'pdf' },
    { label: 'Microsoft Word (.docx)', value: 'docx' },
  ];

  downloadConfig: SelectConfig = {
    placeholder: 'Select file type',
    searchable: false,
    clearable: false,
    styleClass: 'border',
    style: { 'width': '28.125rem' },
    appendTo: 'body'
  };

  selectedType: string = '';
  loading: boolean = false;

  constructor(
    private contractService: ContractService,
  ) { }

  ngOnInit() { }

  closeDialog() {
    this.visibility = false;
    this.visibilityChange.emit(this.visibility);
  }


  downloadDocument(uint8Array: Uint8Array, fileName: string, type: string) {
    const link = document.createElement('a');
    let blob: Blob;
    switch (type) {
      case 'pdf':
        blob = new Blob([new Uint8Array(uint8Array)], {
          type: 'application/pdf'
        });
        link.href = URL.createObjectURL(blob);
        link.download = `${fileName}.pdf`;
        break
      case 'docx':
        blob = new Blob([new Uint8Array(uint8Array)], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
        link.href = URL.createObjectURL(blob);
        link.download = `${fileName}.docx`;
        break
      default:
        break
    }
    document.body.append(link);
    link.click();
    link.remove();
    this.loading = false
  }

  downloadDoc() {
    switch (this.selectedType) {
      case 'pdf':
        this.loading = true
        this.contractService.downloadContract(this.contract._id, 'pdf').subscribe(res => {
          if (res.success) {
            this.downloadDocument(res.data.data, this.contract.name, 'pdf')
          }
        })
        break
      case 'docx':
        this.loading = true
        this.contractService.downloadContract(this.contract._id, 'docx').subscribe(res => {
          if (res.success) {
            this.downloadDocument(res.data.data, this.contract.name, 'docx')
          }
        })
        break
    }
  }
} 
